/**
 * Component initializes experiment algorithms on application startup.
 * Executes only once at the first render of the application.
 */
export default function ExperimentInitializer() {
  // Call experiments hooks - we don't need the data here,
  // but calling the hook will execute the experiment logic
  // useExperimentA()
  // useExperimentB()

  // Return null because this component doesn't render anything visual
  return null
}
